import { z } from 'zod';

export const GetFiatUserAccessResultSchema = z.object({
  accesses: z.array(
    z.object({
      service_name: z.string(),
      currency: z.string(),
      payment_network: z.string(),
      vendor_id: z.string(),
      is_deposit_enable: z.boolean(),
      is_withdraw_enable: z.boolean(),
    }),
  ),
});

export type GetFiatUserAccessResult = z.infer<
  typeof GetFiatUserAccessResultSchema
>;

export interface GetFiatUserAccessParams {}
